module.exports = __webpack_public_path__ + "img/13_DSC8074-min.73bb8cb6.jpg";